import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Session', prop: 'session_id', references: 'admin/sessions', referenceProp: 'long_name' },
  { title: 'Members', prop: 'members_count', format: 'number' },
  { title: 'Coaches', prop: 'coaches_count', format: 'number' }
]

const filters = [
  { name: 'Filter by name', prop: 'filters.name_ilike', type: 'text', enabled: true },
  { name: 'Filter by session', prop: 'filters.session_id', type: 'autocomplete', references: 'admin/sessions', referenceProp: 'name', displayProp: 'long_name', enabled: true },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const defaults = {
  order: [{ column: 'updated_at', direction: 'desc' }]
}

const Groups = (props) => (
  <List
    title='Groups'
    apiPath='admin/groups'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Groups
